export const sandboxFailedHtml = `
<p>Er is helaas iets misgegaan tijdens je aanmelding. Neem <a href="mailto:info@postcodeapi.nu">contact</a> met ons op voor verdere ondersteuning.</p>
`
